import { FlexModuleModelStore } from "src/stores/FlexModuleModelStore";
import { ExtendedFTNode, FTNodeOptions } from "src/typings/flexFramework/FlexComponent";

export interface LobNavigationProps {
  lobs: ExtendedFTNode[];
  flexModuleModelStore: FlexModuleModelStore;
}

export interface LobNavigationItemFTNodeOptions extends FTNodeOptions {
  directLink?: string;
}

export interface LobNavigationItemFTNode extends ExtendedFTNode {
  options: LobNavigationItemFTNodeOptions;
}

export interface LobNavigationItemProps extends NavigationItemProps {
  flexTemplateNode: LobNavigationItemFTNode;
  flexModuleModelStore: FlexModuleModelStore;
  index: number;
  lobsLength: number;
}

export interface LobNavigationItemsProps extends NavigationItemProps {
  lobs: ExtendedFTNode[];
  flexModuleModelStore: FlexModuleModelStore;
}

interface NavigationItemProps {
  searchParams: string;
  getLabel(lobName: string): string;
  isTabChecked(lobName: string): boolean;
  getLobIcon(lobName: string): string;
  handleLobChange(lobName: string, model: any): () => void;
}

export enum scrimValues {
  EMPTY = "",
  LEFT = "left",
  RIGHT = "right",
  BOTH = "both",
}

export interface LobNavigationScrimsProps {
  scrimsToDisplay: scrimValues;
}
